import type { RequestConfig } from '@customTypes/index';
import type { WorkRequestItemDto } from '@customTypes/types';

import { api } from '@/shared/api/instance';

export type RejectWorkRequest = {
  workRequestId: string;
};

export type RejectWorkRequestParams = RequestConfig<RejectWorkRequest>;

export const rejectWorkRequest = async ({
  params,
  config
}: RejectWorkRequestParams) =>
  api.post<WorkRequestItemDto>(
    `/api/work/requests/${params.workRequestId}/reject`,
    config
  );
